module.exports = __webpack_public_path__ + "static/media/why-cash-out-refinancing-may-not-always-make-sense.daa093df.jpeg";